import { useEffect, useState } from 'react'

// The new cellular pay prompt and the old CellularSubscriptionBanner dun the same
// customers, and the banner's "CLICK HERE to renew" starts a *brand new*
// subscription: a customer who has just paid the back-bill could pay twice. So
// while the prompt has something to show for this account, the old banner stands
// down. A module-level store (not a context) keeps this working wherever the two
// are mounted: the prompt lives in the authenticated layout, the banner in pages.
type Listener = (active: boolean) => void

const listeners = new Set<Listener>()

let active = false

export const isCellularPayPromptActive = (): boolean => active

export const setCellularPayPromptActive = (next: boolean): void => {
  if (next === active) return
  active = next
  listeners.forEach(listener => listener(active))
}

export const useCellularPayPromptActive = (): boolean => {
  const [value, setValue] = useState(active)

  useEffect(() => {
    // Mount order is not guaranteed: pick up whatever the prompt already published.
    setValue(isCellularPayPromptActive())
    listeners.add(setValue)
    return () => {
      listeners.delete(setValue)
    }
  }, [])

  return value
}
